export const BRAND = {
    name: "Drvn Dream",
    tagline: "India's most affordable digital library",
};

// wa.me needs the full international format
export const WHATSAPP_NUMBER_DISPLAY = "+91 95559 25080";
export const WHATSAPP_NUMBER = "919555925080";
export const WHATSAPP_MSG =
    "Hi Drvn Dream! I want to get the 12,000+ eBook Mega Bundle (₹199). Please share the payment details.";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;

// Paste your Razorpay / PayU / Instamojo payment page URL here.
// Until it is set, every Buy button falls back to WhatsApp checkout.
export const PAYMENT_LINK =
    "https://superprofile.bio/vp/unlock-12-000--bestselling-ebooks---transform-your-life-today--255";
export const CHECKOUT_URL = PAYMENT_LINK || WHATSAPP_LINK;

export const SUPPORT_EMAIL = "support@drvndream.in";

export const PRICE = {
    current: 199,
    original: 1999,
    save: 1800,
    off: 90,
};

export const IMG = {
    hero: "https://images.unsplash.com/photo-1703332795377-65ccc6818232?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxib29rcyUyMHJlYWRpbmclMjBzdHVkZW50JTIwdGFibGV0JTIwZWJvb2tzJTIwZGlnaXRhbCUyMGxpYnJhcnl8ZW58MHx8fHwxNzkxNDM5OTM0fDA&ixlib=rb-4.1.0&q=85&w=1200",
    reader:
        "https://images.unsplash.com/photo-1676107779674-f77343861e81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxwZXJzb24lMjByZWFkaW5nJTIwdGFibGV0JTIwZWJvb2tzJTIwZGlnaXRhbCUyMGxpYnJhcnl8ZW58MHx8fHwxNzkxNDM5OTM0fDA&ixlib=rb-4.1.0&q=85&w=1200",
    sheets: [
        {
            src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_digital-books-offer/artifacts/39fae26ffdc79d25_books-english-1-Den3nPfc.jpg",
            alt: "English bestsellers — Think & Grow Rich, Rich Dad Poor Dad, Atomic Habits, Ikigai and more",
        },
        {
            src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_digital-books-offer/artifacts/01a69a590c1cf062_books-english-2-HbvLuiZa.jpg",
            alt: "English bestsellers — The Psychology of Money, Zero to One, Sales Bible, Built to Last and more",
        },
        {
            src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_digital-books-offer/artifacts/5a9be951ce95af49_books-hindi-1-CTvy42eW.jpg",
            alt: "Hindi bestsellers — अपके अवचेतन मन की शक्ति, सोच बदलो जिंदगी बदलो, हर हाल में जीतोगे and more",
        },
        {
            src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_digital-books-offer/artifacts/da9136062601180a_books-hindi-2-DcJwjdss.jpg",
            alt: "Hindi bestsellers — धन को आकर्षित कैसे करें, रिच डैड पुअर डैड, माइंडसेट, बड़ी सोच का बड़ा जादू and more",
        },
    ],
};
